import React, { useState, useEffect } from 'react';
import { FaArrowRight, FaGift, FaPhoneAlt } from 'react-icons/fa';
import { useLanguage } from './LanguageContext';
import ContactForm from './ContactForm';
import Snackbar from './Snackbar';
import ProductModal from './ProductModal';
import { sendContactData } from './services/contactService';
// ИМПОРТИРУЕМ ВСЕ НУЖНЫЛЕ ФУНКЦИИ
import { getProducts, getCategories } from './firebase/productsService';
// 🔥 1. УДАЛЯЕМ ВСЁ, ЧТО СВЯЗАНО С FIREBASE VIDEO
// import { getVideoUrl, VIDEO_PATHS } from './firebase/videoService';
import './MobileMainContent.css';
import AboutSection from './AboutSection';
import MobileSlider from './components/MobileSlider';
import MobileProductGrid from './MobileProductGrid';
import MainSlider from './MainSlider';


// Импорты ассетов
import deliveryIcon from './assets/delivery-truck-icon.png';
import comfortIcon from './assets/feature-icon-4.svg';
import qualityIcon from './assets/quality-icon.png';
import pillowsImage from './assets/pillows.png';
import gazelImage from './assets/kazakhstan-map.png';
import pindrop from './assets/pindrop.png';

const MobileMainContent = () => {
    const { t, language } = useLanguage();
    const [isFormOpen, setIsFormOpen] = useState(false);
    const [snackbar, setSnackbar] = useState({ isOpen: false, message: '', type: 'success' });

    // === НОВАЯ, СУКА, ЛОГИКА ЗАГРУЗКИ ===
    const [categories, setCategories] = useState([]);
    const [allProducts, setAllProducts] = useState([]);
    // ИЗМЕНЕНИЕ: initialLoading нам больше не нужен, убираем его
    // const [initialLoading, setInitialLoading] = useState(true); 
    const [contentLoading, setContentLoading] = useState(true); // Остается только лоадер для контента
    // ===================================

    const [selectedProduct, setSelectedProduct] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    // 🔥 3. УПРОЩАЕМ ЗАГРУЗКУ В useEffect
    useEffect(() => {

        const loadContent = async () => {
            try {
                // Запускаем запросы к Firebase за категориями и товарами параллельно
                const [categoriesData, productsData] = await Promise.all([
                    getCategories(),
                    getProducts(),
                ]);

                setCategories(categoriesData.filter(cat => cat.isActive));
                // Сортируем продукты по полю order (по возрастанию)
                // Если order отсутствует, используем 0 как значение по умолчанию
                const sortedProducts = [...productsData].sort((a, b) => {
                    const orderA = a.order !== undefined ? a.order : 0;
                    const orderB = b.order !== undefined ? b.order : 0;
                    return orderA - orderB;
                });
                setAllProducts(sortedProducts);

            } catch (error) {
            } finally {
                setContentLoading(false); // Выключаем лоадер контента
            }
        };

        loadContent();

    }, []); // Пустой массив = один раз при загрузке
    // =================================

    // Хендлеры (без изменений)
    const handleOpenForm = () => setIsFormOpen(true);
    const handleCloseForm = () => setIsFormOpen(false);
    const handleCloseSnackbar = () => setSnackbar(prev => ({ ...prev, isOpen: false }));
    const handleFormSubmit = async (formData) => {
        setTimeout(() => setSnackbar({ isOpen: true, message: t('successMessage'), type: 'success' }), 1000);
        try {
            await sendContactData({ ...formData, source: 'mobile-main-button', language: language });
        } catch (error) { }
    };
    const handleProductClick = (product) => {
        setSelectedProduct(product);
        setIsModalOpen(true);
    };
    const handleCloseModal = () => {
        setIsModalOpen(false);
        setSelectedProduct(null);
    };

    // === УБИРАЕМ, БЛЯТЬ, ГЛАВНЫЙ ЛОАДЕР ===
    // if (initialLoading) { ... }

    return (
        <>
            <main className="mobile-main-content">
                {/* Эта часть теперь рисуется СРАЗУ, без ожидания */}
                <MobileSlider />
                <div className="mobile-cta-section">
                    <button className="mobile-cta-button" onClick={handleOpenForm}>
                        {t('getConsultation')}
                        <FaArrowRight />
                    </button>
                </div>
                <div className="mobile-features-blocks">
                    <div className="mobile-feature-block">
                        <img src={deliveryIcon} alt="Доставка" className="mobile-feature-icon" />
                        <p className="mobile-feature-text">{t('freeDelivery')}</p>
                    </div>
                    <div className="mobile-feature-block">
                        <img src={comfortIcon} alt="Комфорт" className="mobile-feature-icon" />
                        <p className="mobile-feature-text">{t('individualComfort')}</p>
                    </div>
                    <div className="mobile-feature-block">
                        <img src={qualityIcon} alt="Качество" className="mobile-feature-icon" />
                        <p className="mobile-feature-text">{t('qualityGuarantee')}</p>
                    </div>
                </div>
                <div className="mobile-catalog-promo">
                    <div className="mobile-promo-banner">
                        <div className="mobile-promo-text">
                            {t('promoText')}
                        </div>
                        <div className="mobile-promo-image">
                            <FaGift className="mobile-gift-icon" />
                            <img
                                src={pillowsImage}
                                alt="Подушки"
                                className="mobile-pillows-img"
                            />
                        </div>
                    </div>
                </div>

                <div className="mobile-video-section">
                    <div className="mobile-video-container">
                        <MainSlider />
                    </div>
                </div>

                {contentLoading ? (
                    <div className="mobile-loading" style={{ padding: '40px 0', textAlign: 'center' }}>Загрузка каталога...</div>
                ) : (
                    categories.length > 0 ? (
                        categories.map(category => {
                            const productsForCategory = allProducts.filter(p => (p.type || 'pruzhinnyy') === category.id);
                            // Сортируем продукты внутри категории по полю order (по возрастанию)
                            // Если order отсутствует, используем 0 как значение по умолчанию
                            const sortedProductsForCategory = [...productsForCategory].sort((a, b) => {
                                const orderA = a.order !== undefined ? a.order : 0;
                                const orderB = b.order !== undefined ? b.order : 0;
                                return orderA - orderB;
                            });

                            return sortedProductsForCategory.length > 0 ? (
                                <MobileProductGrid
                                    key={category.id}
                                    title={category.title}
                                    subtitle={category.subtitle}
                                    products={sortedProductsForCategory}
                                    onProductClick={handleProductClick}
                                />
                            ) : null;
                        })
                    ) : (
                        <div className="mobile-no-products" style={{ padding: '40px 16px', textAlign: 'center', color: '#666' }}>
                            <h3>Каталог пуст</h3>
                            <p>Мы уже работаем над добавлением новых товаров. Загляните позже!</p>
                        </div>
                    )
                )}

                <div className="mobile-delivery-section">
                    <h2 className="mobile-delivery-main-title">{t('delivery')}</h2>
                    <h2 className="mobile-delivery-title">{t('freeDeliveryKazakhstan')}</h2>
                    <div className="mobile-delivery-info">
                        <div className="mobile-delivery-item">
                            <div className="mobile-delivery-icon">
                                <img src={deliveryIcon} alt={t('deliveryAlmaty')} />
                            </div>
                            <div className="mobile-delivery-text">
                                <h3>{t('deliveryAlmaty')}</h3>
                                <p>{t('deliveryAlmatyDesc')}</p>
                            </div>
                        </div>
                        <div className="mobile-delivery-item">
                            <div className="mobile-delivery-icon">
                                <img src={pindrop} alt={t('deliveryOtherCities')} />
                            </div>
                            <div className="mobile-delivery-text">
                                <h3>{t('deliveryOtherCities')}</h3>
                                <p>{t('deliveryOtherCitiesDesc')}</p>
                            </div>
                        </div>
                    </div>
                    <div className="mobile-delivery-image-card">
                        <img src={gazelImage} alt={t('freeDeliveryKazakhstan')} />
                    </div>
                </div>

                <AboutSection />

                <footer className="mobile-footer js-stop-point">
                    <div className="mobile-footer-content">
                        <div className="mobile-footer-left">
                            <div className="mobile-footer-logo">
                                <span className="mobile-logo-text">AI-SON</span>
                            </div>
                            <div className="mobile-footer-contact">
                                <h3 className="mobile-footer-question">{t('anyQuestions')}</h3>
                                <p className="mobile-footer-call">{t('callUs')}</p>
                                <div className="mobile-footer-phone">
                                    <FaPhoneAlt className="mobile-phone-icon" />
                                    <a href="tel:+77073171819" className="mobile-phone-number">+7 707 317 18 19</a>
                                </div>
                            </div>
                        </div>
                        <div className="mobile-footer-right">
                            <h3 className="mobile-footer-follow">{t('followSocial')}</h3>
                            <div className="mobile-footer-social">
                                <a href="https://www.instagram.com/aison.matras/" target="_blank" rel="noopener noreferrer" className="mobile-social-link instagram">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" /></svg>
                                </a>
                                <a href="https://www.tiktok.com/@aison.matras" target="_blank" rel="noopener noreferrer" className="mobile-social-link tiktok">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor"><path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" /></svg>
                                </a>
                                <a href="https://t.me/aison_kz" target="_blank" rel="noopener noreferrer" className="mobile-social-link telegram">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor"><path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" /></svg>
                                </a>
                            </div>
                        </div>
                    </div>
                </footer>
            </main>

            <ContactForm isOpen={isFormOpen} onClose={handleCloseForm} onSubmit={handleFormSubmit} />
            <Snackbar isOpen={snackbar.isOpen} message={snackbar.message} type={snackbar.type} onClose={handleCloseSnackbar} duration={5000} />
            {isModalOpen && selectedProduct && (
                <ProductModal product={selectedProduct} isOpen={isModalOpen} onClose={handleCloseModal} />
            )}
        </>
    );
};

export default MobileMainContent;
